'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORT_FEATURES = exports.META_COLUMNS = exports.REPORT_TYPES = exports.RUN_FILE_TYPE_CONFIG = exports.DISPLAYED_REPORT_FIELDS = exports.RUN_STATUS_CONFIG = exports.CRAWL_COMPARE_REPORT_TYPE = exports.CRAWL_REPORT_REPORT_TYPE = exports.CRAWL_DIFF_REPORT_TYPE = exports.MATCH_TYPE_FUZZY = exports.MATCH_TYPE_EXACT = exports.NEW_REPORT_GUID = undefined;
var _colors = require('./colors');
var _colors2 = _interopRequireDefault(_colors);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// Report Creation
var NEW_REPORT_GUID = exports.NEW_REPORT_GUID = 'new';

// Fuzzy Matching
var MATCH_TYPE_EXACT = exports.MATCH_TYPE_EXACT = 'EXACT';
var MATCH_TYPE_FUZZY = exports.MATCH_TYPE_FUZZY = 'FUZZY';

// Report Slugs
var CRAWL_DIFF_REPORT_TYPE = exports.CRAWL_DIFF_REPORT_TYPE = 'CRAWL_DIFF';
var CRAWL_REPORT_REPORT_TYPE = exports.CRAWL_REPORT_REPORT_TYPE = 'CRAWL_REPORT';
var CRAWL_COMPARE_REPORT_TYPE = exports.CRAWL_COMPARE_REPORT_TYPE = 'CRAWL_COMPARE';
var RUN_STATUS_CONFIG = exports.RUN_STATUS_CONFIG = {
  STARTED: {
    spin: true,
    name: 'Started',
    slug: 'STARTED',
    color: _colors2.default.IO_STEEL,
    icon: 'circle-o-notch'
  },
  PENDING: {
    spin: true,
    name: 'Pending',
    slug: 'PENDING',
    color: _colors2.default.IO_STEEL,
    icon: 'circle-o-notch'
  },
  CANCELLED: {
    spin: false,
    name: 'Cancelled',
    slug: 'CANCELLED',
    color: _colors2.default.WARNING,
    icon: 'exclamation-circle'
  },
  FAILED: {
    spin: false,
    name: 'Failed',
    slug: 'FAILED',
    color: _colors2.default.DANGER,
    icon: 'times-circle'
  },
  COMPLETE: {
    spin: false,
    name: 'Completed',
    slug: 'COMPLETE',
    color: _colors2.default.SUCCESS,
    icon: 'check-circle'
  },
  FINISHED: {
    spin: false,
    name: 'Completed',
    slug: 'FINISHED',
    color: _colors2.default.SUCCESS,
    icon: 'check-circle'
  }
};

// Report Summary Fields
var DISPLAYED_REPORT_FIELDS = exports.DISPLAYED_REPORT_FIELDS = {
  added: {
    title: 'Added'
  },
  changed: {
    title: 'Changed'
  },
  removed: {
    title: 'Removed'
  },
  rowsProcessed: {
    title: 'Total Rows'
  },
  linkedRecords: {
    title: 'Linked records'
  },
  unmatchedRecords: {
    title: 'Unmatched records'
  },
  numberOfExtractors: {
    title: 'Number of extractors'
  }
};
var RUN_FILE_TYPE_CONFIG = exports.RUN_FILE_TYPE_CONFIG = {
  pdf: {
    name: 'PDF',
    color: 'red',
    attachment: 'pdf',
    icon: 'file-pdf-o'
  },
  csv: {
    name: 'CSV',
    color: 'purple',
    attachment: 'csv',
    icon: 'file-text-o'
  },
  xlsx: {
    name: 'Excel',
    color: 'green',
    attachment: 'xlsx',
    icon: 'file-excel-o'
  }
};

// Report Types
var REPORT_TYPES = exports.REPORT_TYPES = [{
  slug: CRAWL_REPORT_REPORT_TYPE,
  features: {
    name: 'Data',
    shortName: 'data',
    uiType: 'matrix',
    permission: 'CRAWL_REPORT',
    icon: 'database',
    matchType: false,
    canAccess: false,
    canDuplicate: true,
    minRows: 1,
    maxRows: 1,
    minColumns: 1,
    minExtractorRuns: 0,
    hasMaster: false,
    hasPrimary: false,
    canClearCell: false,
    requireValidation: true
  }
}, {
  slug: CRAWL_COMPARE_REPORT_TYPE,
  features: {
    name: 'Comparison',
    shortName: 'comp',
    uiType: 'matrix',
    permission: 'CRAWL_COMPARE',
    icon: 'balance-scale',
    matchType: 'FUZZY',
    canAccess: false,
    canDuplicate: true,
    minRows: 2,
    maxRows: false,
    minColumns: 1,
    minExtractorRuns: 0,
    hasMaster: true,
    hasPrimary: true,
    forceMaster: true,
    canClearCell: true,
    requirePrimary: true,
    requireValidation: true
  }
}, {
  slug: CRAWL_DIFF_REPORT_TYPE,
  features: {
    name: 'Change',
    shortName: 'change',
    uiType: 'drag',
    permission: 'DIFF_MONITORING',
    icon: 'exchange',
    minExtractorRuns: 2,
    canAccess: false,
    canDuplicate: false,
    requireExtractor: true
  }
}];
var META_COLUMNS = exports.META_COLUMNS = [{
  _isMeta: true,
  id: 'SCREEN_CAPTURE',
  name: 'Screen Capture Url'
}, {
  _isMeta: true,
  id: 'EXTRACTION_DATE',
  name: 'Extraction Date'
}, {
  _isMeta: true,
  id: 'URL',
  name: 'URL'
}, {
  _isMeta: true,
  id: 'SOURCE_URL',
  name: 'Source Url'
}];
REPORT_TYPES.forEach(Object.freeze);
var REPORT_FEATURES = exports.REPORT_FEATURES = {};
REPORT_TYPES.forEach(function (type) {
  REPORT_FEATURES[type.slug] = type.features;
});
Object.freeze(REPORT_FEATURES);